
import {http as httpLogin, httpWithoutHeader, API_URL, httpVeryfied } from '../config'
import { http } from "../http";
import { secureLocalStorageSet } from '../../helpers';

export const getGoogleAuthDataService = (args: Object):Promise<any> => {
  return new Promise((resolve, reject) => {
      http.post(`auth/login`, args)
      .then(response => {
        if (response) {
          resolve(response)
        } else {
          reject(response)
        }
      })
      .catch(error => {
        reject(error)
      })
  })
}
export const verifyAuth = (args: Object):Promise<any> => {
  return new Promise((resolve, reject) => {
      httpLogin()
      .post(`${API_URL}auth/login/verify`, args)
      .then(response => {
        if (response) {
          resolve(response)
        } else {
          reject(response)
        }
      })
      .catch(error => {
        reject(error)
      })
  })
}

export const getPasswordChange = (args: Object):Promise<any> => {  
  return new Promise((resolve, reject) => {
      http.post(`auth/changepassword`, args)
      .then(response => {
        if (response) {
          resolve(response)
        } else {
          reject(response)
        }
      })
      .catch(error => {
        reject(error)
      })
  })
}

export const verifyPasswordChange = (args: Object):Promise<any> => {
  return new Promise((resolve, reject) => {
    // httpLogin()
    //   .post(`auth/changepassword/verify`, args)
    http.post(`auth/changepassword/verify`, args)
      .then(response => {
        if (response) {
          resolve(response)
        } else {
          reject(response)
        }
      })
      .catch(error => {
        reject(error)
      })
  })
}

export const logoutService = ():Promise<any> => {
  return new Promise((resolve, reject) => {
      http.post(`auth/logout`, {})
      .then(response => {
        if (response) {
          resolve(response)
        } else {
          reject(response)
        }
      })
      .catch(error => {
        reject(error)
      })
  })
}

export const getTokenDataService = (args: Object):Promise<any> => {
  return new Promise((resolve, reject) => {
      httpWithoutHeader().post(`${API_URL}auth/asan`, args)
      .then(response => {
        if (response) {
          resolve(response)
        } else {
          reject(response)
        }
      })
      .catch(error => {
        reject(error)
      })
  })
}

export const getSIMADataService = (channel: string = 'INT'): Promise<any> => {
  return new Promise((resolve, reject) => {
    // The SIMA QR request now requires a channel in the body ("INT" for web,
    // "MOBIL" for mobile) instead of an empty object.
    http.post('auth/sima', { channel })
      .then(response => {
        if (response) resolve(response)
        else reject(response)
      })
      .catch(error => reject(error))
  })
}

export const checkSIMAStatusService = (): Promise<any> => {
  return new Promise((resolve, reject) => {
    // Status polling moved from GET auth/sima to POST auth/sima/status with an
    // empty body.
    httpLogin()
      .post(`${API_URL}auth/sima/status`, {})
      .then(response => {
        if (response) resolve(response)
        else reject(response)
      })
      .catch(error => reject(error))
  })
}

export const  getAuthorizationValue = (history: any) => {
  return new Promise((resolve, reject) => {
    function checkResponse() {
      httpLogin()
      .get(`${API_URL}auth/asan`)
      .then((response:any) => {
        if (response.data.mSignStatus == 'AUTHORIZED' && response.data.result == 1 ) {
            let userAsanData = {
                customerData : response.data.customers.asanCustomerList, 
                permissions :response.data.permissions,
                userName: response.data.userName,
                usersSurName: response.data.usersSurName
            }
            // localStorage.setItem("currentCompany", JSON.stringify(response.data.customers.asanCustomerList[0]))
            if(response.data.customers.asanCustomerList.length!==1){
            var fav = response.data.customers.asanCustomerList.find(e => e.favorite === 'Y')

            }else{
              var fav = response.data.customers.asanCustomerList[0]

            }
console.log(fav)

            secureLocalStorageSet("currentCompany", fav)
            localStorage.setItem("auth_token_verifyed", response.headers.auth_token)
            // localStorage.setItem('userData',JSON.stringify(userAsanData))
            secureLocalStorageSet('userData', userAsanData)
            secureLocalStorageSet('username', response.data.userName)
            secureLocalStorageSet("channel", 'ASAN')
            secureLocalStorageSet("rol", response.data.role)
            // localStorage.setItem("rol", response.data.role)
            // localStorage.setItem("permissions", JSON.stringify(response.data.permissions))
            secureLocalStorageSet('permissions', response.data.permissions)
            history.push('/')
            resolve(response)
        } else if (response.data.mSignStatus == 'CANCELLED' || response.data.mSignStatus == 'SIM_ERROR' || response.data.result == 350 || (response.data.errMessage !== "" && response.data.errMessage !== null)) {
           history.push('/login')
           resolve(response)
      } else if(response.data.mSignStatus == 'OUTSTANDING'){
        window.setTimeout(checkResponse, 1000); 
      } else {
          reject(response)
      }
    })}
    checkResponse()
  })
}

